import { render, staticRenderFns } from "./ShippingInfoModal.vue?vue&type=template&id=73eca796&scoped=true"
import script from "./ShippingInfoModal.vue?vue&type=script&lang=ts"
export * from "./ShippingInfoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eca796",
  null
  
)

export default component.exports